import { ManageSurgeListList } from './ManageSurgeListList';

export const options = { label: 'Manage Surge List' };

export const list = ManageSurgeListList;
